/**
 * Registers the SARTN service worker for offline support.
 * Only registers in production when the browser supports service workers.
 */
export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.info("[SW] Registered:", registration.scope);
      })
      .catch((registrationError) => {
        console.warn("[SW] Registration failed:", registrationError);
      });
  });
}
